// src/components/PathPage.js (Finalized structure using multi-tab content)

import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ResourceCard from './ResourceCard'; 
import { PATH_ROADMAPS, toSlug } from './data/mockRoadmaps.js'; 
import './PathPage.css';


const PathPage = () => {
    const { pathSlug } = useParams();
    const [pathData, setPathData] = useState(null);
    const [activeTab, setActiveTab] = useState('resources'); 

    useEffect(() => {
        // Fetch data using the slug directly from the URL
        const data = PATH_ROADMAPS[pathSlug];

        if (data) {
            setPathData(data);
        } else {
             // Handle 'Path Not Found' when the slug is truly invalid
             setPathData({
                title: 'Path Not Found',
                description: `No specific roadmap data found for: ${pathSlug}.`,
                resources: [], articles: [], videos: []
             });
        }
        setActiveTab('resources'); 
    }, [pathSlug]);

    if (!pathData) {
        return <div className="loading-spinner">Loading path details...</div>;
    }

    // Function to render content based on the active tab
    const renderContent = () => {
        let contentList = [];
        let emptyMessage = "";

        if (activeTab === 'resources') {
            contentList = pathData.resources;
            emptyMessage = "No essential courses, books, or tools listed yet.";
        } else if (activeTab === 'articles') {
            contentList = pathData.articles;
            emptyMessage = "No relevant blogs or news articles listed yet.";
        } else if (activeTab === 'videos') {
            contentList = pathData.videos;
            emptyMessage = "No tutorial or educational videos listed yet.";
        }

        if (contentList.length === 0) {
            return <div className="no-resources">{emptyMessage}</div>;
        }

        return (
            <div className="resources-grid">
                {contentList.map((resource, index) => (
                    // We need to ensure we pass the correct props to ResourceCard
                    <ResourceCard key={index} {...resource} />
                ))}
            </div>
        );
    };

    return (
        <div className="path-page section-padding">
            <div className="main-content">
                
                {/* --- 1. Hero Section (Shows Path Not Found if data is missing) --- */}
                <header className="path-hero">
                    <h1 className="path-title">{pathData.title}</h1>
                    <p className="path-description">{pathData.description}</p>
                    
                    {pathData.title !== 'Path Not Found' && (
                        <Link to="/onboarding" className="btn-primary start-path-btn">
                            Start This Path Now
                        </Link>
                    )}
                </header>

                <hr/>

                {/* --- 2. Tab Navigation --- */}
                <nav className="path-tabs">
                    <button 
                        className={`tab-button ${activeTab === 'resources' ? 'active' : ''}`}
                        onClick={() => setActiveTab('resources')}
                    >
                        Essential Resources
                    </button>
                    <button 
                        className={`tab-button ${activeTab === 'articles' ? 'active' : ''}`}
                        onClick={() => setActiveTab('articles')}
                    >
                        Blogs & News
                    </button>
                    <button 
                        className={`tab-button ${activeTab === 'videos' ? 'active' : ''}`}
                        onClick={() => setActiveTab('videos')}
                    >
                        Tutorial Videos
                    </button>
                </nav>

                {/* --- 3. Content Display --- */}
                <div className="path-content-area">
                    <h2 className="resources-heading">Curated Content</h2>
                    {renderContent()}
                </div>

            </div>
        </div>
    );
};

export default PathPage;